import { USER_REGION_COOKIE_EXPIRATION_YEARS } from '~shared/modules/region-selector/constants/user-region-cookie.constant';

export function createUserRegionCookieExpiration() {
  const date = new Date();
  const year = date.getFullYear() + USER_REGION_COOKIE_EXPIRATION_YEARS;
  date.setFullYear(year);
  return date;
}
